import { registerPropertyManagerSection } from '@/core';
import InsertComponentPropertySection from '@/components/editor/property-manager/insert-component/InsertComponentPropertySection.vue';

registerPropertyManagerSection({
  id: 'insert-component',
  title: '插入零部件',
  order: 35,
  component: InsertComponentPropertySection,
  actions: {
    confirm: true,
    cancel: true,
  },
  isApplicable: (context) => {
    return Boolean(context.insertComponentActive);
  },
  resolveConfirmDisabled: (context) => {
    return (context.selectedInsertComponentFiles?.length ?? 0) === 0;
  },
  onConfirm: (context) => {
    context.confirmInsertComponentSelection?.();
  },
  onCancel: (context) => {
    context.cancelInsertComponent?.();
  },
});
